import { createContext, useContextSelector } from '@fluentui/react-context-selector';
/**
 * RadioGroupContext is provided by RadioGroup, and is consumed by Radio to determine default values of some props.
 */

export const RadioGroupContext = /*#__PURE__*/createContext(undefined);
const radioGroupContextDefaultValue = {};
export const RadioGroupProvider = RadioGroupContext.Provider;
export const useRadioGroupContext_unstable = selector => useContextSelector(RadioGroupContext, (ctx = radioGroupContextDefaultValue) => selector(ctx));
//# sourceMappingURL=RadioGroupContext.js.map